module.exports = __webpack_public_path__ + "img/flatfish.ada1a02f.png";